import React, {useEffect} from "react";
import {Controller, useForm} from "react-hook-form";
import {TpdRecaptchaFactoryService} from "@tpd-web-react-libs/nodejs-library/dist/src/utils";
import {
    TpdRecaptchaResponseClass
} from "@tpd-web-react-libs/nodejs-library/dist/src/utils/recaptcha/classes/tpd-recaptcha-response.class";
import {
    TpdRecaptchaStatus
} from "@tpd-web-react-libs/nodejs-library/dist/src/utils/recaptcha/models/tpd-recaptcha-status.enum";
import {IFormConfig} from "@tpd-web-react-libs/nodejs-library/dist/src/interfaces";
import {UsInput} from "@tpd-web-react-libs/nodejs-library/dist/src/components";
import {goToRegistration, removeLeadingSpace} from "./LoginHelper";
import { Subscription } from "react-hook-form/dist/utils/createSubject";


type TFormLogin = {
    username: string;
    password: string;
};

export type TLoginFormProps = {
    disabled?: boolean;
    isCaptchaDisabled?: boolean;
    onSubmit?: (username: string, password: string, captchaToken: string) => void;
    onLoadStart?: () => void;
    onLoadEnd?: () => void;
    onTemporaryPasswordDetected?: (username: string, password: string) => void;
    onLoginError?: () => void;
    authFailed?: boolean;
};

const CAPTCHA_ID = "tpd-login-header-captcha";


export const LoginForm = (props: TLoginFormProps) => {
    const tpdRecaptchaFactoryService = TpdRecaptchaFactoryService.getInstance();
    const {
        control,
        handleSubmit,
        formState: {isValid},
        getValues
    } = useForm<TFormLogin>({});

    const formConfig: IFormConfig = {
        username: {
            name: "username",
            placeholder: "Email/Username",
            defaultValue: "",
            rules: {
                required: true,
            },
            transform: {
                input: removeLeadingSpace,
                output: removeLeadingSpace,
            }
        },
        password: {
            name: "password",
            placeholder: "Password",
            type: "password",
            defaultValue: "",
            rules: {
                required: true,
            }
        },
    }


    // RECAPTCHA - START
    useEffect(() => {
        if (props.isCaptchaDisabled) disableRecaptcha();
    }, [props.isCaptchaDisabled]);

    useEffect(() => {
        disableRecaptcha();
        const subscription: Subscription = tpdRecaptchaFactoryService
            .createRecaptcha(CAPTCHA_ID)
            .subscribe({
                next: (response: TpdRecaptchaResponseClass) => {
                    if (response.status === TpdRecaptchaStatus.OK) {
                        // login(getValues("username"), getValues("password"), response.token);
                        props.onSubmit && props.onSubmit(getValues("username"), getValues("password"), response.token);
                    } else {
                        props.onLoadEnd();
                    }
                },
                error: (e) => {
                    console.error("Errore createRecaptcha: ", e);
                    props.onLoadEnd();
                },
            });

        return () => {
            subscription.unsubscribe();
        };
    }, []);


    const executeCaptcha = () => {
        props.onLoadStart();
        tpdRecaptchaFactoryService.executeReCaptcha(CAPTCHA_ID);
    }

    const disableRecaptcha = () => {
        tpdRecaptchaFactoryService.resetRecaptcha(CAPTCHA_ID);
    }
    // RECAPTCHA - END

    return (
        <>
            <div className="us-row login-dropdown_btn_wrapper">
                <form onSubmit={handleSubmit(executeCaptcha)} >
                    <div className="login-dropdown_btn col-xs-22 col-xs-offset-1 col-md-11 col-md-offset-1 col-lg-14 col-lg-offset-2">
                        <Controller
                            control={control}
                            {...formConfig.username}
                            name={"username"}
                            render={({field, fieldState}) => (
                                <UsInput
                                    className="login-dropdown_input"
                                    config={formConfig.username}
                                    {...formConfig.username}
                                    {...field}
                                    {...fieldState}
                                    onChange={formConfig.username.transform?.output ?
                                        (e) => field.onChange(formConfig.username.transform.output(e.target.value)) : field.onChange}
                                    value={formConfig.username.transform?.input ?
                                        formConfig.username.transform.input(field.value) : field.value}
                                />
                            )}
                        />
                    </div>
                    <div className="login-dropdown_btn col-xs-22 col-xs-offset-1 col-md-11 col-md-offset-1 col-lg-14 col-lg-offset-2">
                        <Controller
                            control={control}
                            {...formConfig.password}
                            name={"password"}
                            render={({field, fieldState}) => (
                                <UsInput
                                    className="login-dropdown_input"
                                    config={formConfig.password}
                                    {...formConfig.password}
                                    {...field}
                                    {...fieldState}
                                />
                            )}
                        />
                    </div>
                    <div>
                        {/* this button has been added in order manage submit of the form on enter press*/}
                        <button
                            style={{'display': 'none'}}
                            disabled={props.disabled}
                            type='submit'
                        > 
                    </button>
                    </div>
                </form>
            </div>

            {/* ERRORS */}
            {props.authFailed && (
                <div className="us-row">
                    <div
                        className="login-dropdown_btn col-xs-22 col-xs-offset-1 col-md-11 col-md-offset-1 col-lg-14 col-lg-offset-2">
                        <h3
                            className="text-contact"
                            aria-label="Username o password non validi"
                            role="alert"
                        >
                            Username o password non validi
                        </h3>
                    </div>
                </div>
            )}
            {/* CTAS */}
            <div className="us-row">
                <div
                    className="tpd_ipt_recupera_pwd col-xs-22 col-xs-offset-1 col-md-12 col-md-offset-0 col-lg-8 col-lg-offset-2">
                    <a
                        href="/accesso?recuperaEmail=true"
                        title="Recupera Email"
                    >
                        Recupera dati di accesso
                    </a>
                </div>
            </div>
            {/* SUBMIT */}
            <div className="us-row">
                <div className="col-xs-22 col-xs-offset-1 col-md-22 col-md-offset-1 col-lg-20 col-lg-offset-2">
                    <button
                        className="login-dropdown_btn_accedi"
                        disabled={props.disabled}
                        onClick={handleSubmit(executeCaptcha)}
                    >
                        ACCEDI
                    </button>
                </div>
            </div>

            <div className="us-row login-dropdown_privacy col-xs-22 col-xs-offset-1 col-md-22 col-md-offset-1 col-lg-20 col-lg-offset-2">
                <span>
                    <a
                        href="https://www.google.com/intl/it/policies/privacy/"
                        target="_blank"
                        rel="noreferer, ,noopener"
                    >
                        Protetto da reCaptcha Privacy
                    </a>
                    &nbsp;-&nbsp;
                    <a
                        href="https://www.google.com/intl/it/policies/terms/"
                        target="_blank"
                        rel="noreferer, ,noopener"
                    >
                        Termini
                    </a>
                </span>
            </div>

            <div className="us-row">
                <div
                    className="tpd_description col-xs-22 col-xs-offset-1 col-md-22 col-md-offset-1 col-lg-20 col-lg-offset-2">
                    Non sei registrato?&nbsp;
                    <span
                        onClick={goToRegistration}
                        className="tpd_description_btn"
                        title="Registrati"
                    >
                        Registrati ora
                    </span>
                </div>
            </div>
        </>
    )
        ;
}

LoginForm.defaultProps = {
    disabled: false,
    isCaptchaDisabled: false,
}
